<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['emp.apptype.entrance']">
<!--              <a-input :placeholder="language['column.pleaseChoose']+language['emp.apptype.entrance']"  v-model="queryParam.entranceId"></a-input>-->
              <a-select
                allowClear
                :placeholder="language['column.pleaseChoose']+language['emp.apptype.entrance']"
                v-model="queryParam.entranceId"
              >
                <a-select-option v-for="(item,index) in entrances" :key="index.toString()" :value="item.id">
                  {{ item.entranceName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['emp.apptype.apptypeCode']">
              <a-input :placeholder="language['common.pleaseInput']+language['emp.apptype.apptypeCode']" v-model="queryParam.appTypeCode" allowClear></a-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="language['emp.apptype.apptypeName']">
                <a-input :placeholder="language['common.pleaseInput']+language['emp.apptype.apptypeName']" v-model="queryParam.appTypeName" allowClear></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="language['emp.apptype.status']">
                <j-dict-select-tag :placeholder="language['column.pleaseChoose']+language['emp.apptype.status']" v-model="queryParam.publishStatus" dictCode="sys_portal_up_down" allowClear/>
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? language['common.foldButton'] : language['common.unfoldButton'] }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" v-has="'apptype:insert'" type="primary" icon="plus">{{language['common.insertButton']}}</a-button>
<!--      <a-button type="primary" icon="download" @click="handleExportXls('emp_base_apptype')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>-->
      <!-- 高级查询区域 -->
<!--      <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query>-->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" v-has="'apptype:batchDel'" @click="batchDel"><a-icon type="delete"/>{{language['common.delete']}}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{language['common.batchAction']}} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{language['common.choosed']}} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{language['common.item']}}
        <a style="margin-left: 24px" @click="onClearSelected">{{language['common.clear']}}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <template slot="imgSlot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ language['common.noPicture'] }}</span>
            <img v-else :src="getImgViewCode(text,applicationCode)" @click="imgView(getImgViewCode(text,applicationCode))" alt="" style="font-size: 12px;font-style: italic;cursor: pointer;"/>
          </div>
          <a-modal
            :mask="false"
            :width="1000"
            :title="language['ad.image']"
            :visible="previewVisible"
            :confirm-loading="false"
            :ok-button-props="{ props: { disabled: true } }"
            @cancel="handleCancel"
            :cancelText="language['common.closeButton']">
            <img alt="example" style="width: 100%;" :src="previewImage" />
          </a-modal>
        </template>

        <span slot="action" slot-scope="text, record">
          <a href="javascript:;" v-has="'apptype:applist'" @click="applicationList(record.id,record.appTypeName,record.entranceName)">{{language['user.apply.list']}}</a>
          <a-divider type="vertical" v-has="'apptype:applist'" />

          <a @click="handleEdit(record)" v-has="'apptype:edit'" >{{language['common.edit']}}</a>
          <a-divider type="vertical" v-has="'apptype:edit'"/>

          <a href="javascript:;" v-has="'apptype:unitApp'"  @click="handleApplications(record.id,record.appTypeName,record.entranceId)">{{language['portal.unitApp']}}</a>
          <a-divider type="vertical" v-has="'apptype:unitApp'" />

          <a @click="publish(record)" v-has="'apptype:updown'" v-if="record.publishStatus=='down'">{{language['sys.dict.appstatus.publish']}}</a>
          <a @click="unpublish(record)" v-has="'apptype:updown'" v-if="record.publishStatus=='up'">{{language['sys.dict.appstatus.unpublish']}}</a>

          <a-divider type="vertical" v-has="'apptype:updown'" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{language['common.more']}} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item v-has="'apptype:detail'" >
                <a @click="handleDetail(record)">{{language['common.detailsButton']}}</a>
              </a-menu-item>
              <a-menu-item v-has="'apptype:delete'" >
                <a-popconfirm :title="language['common.deleteConfirmInfo']" @confirm="() => handleDelete(record.id)">
                  <a>{{language['common.delete']}}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <emp-base-apptype-modal ref="modalForm" @ok="modalFormOk"></emp-base-apptype-modal>
    <apptype-application-modal ref="apptypeApplicatonModal"></apptype-application-modal>
    <apptype-application-list-modal ref="apptypeApplicatonListModal"></apptype-application-list-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EmpBaseApptypeModal from './modules/EmpBaseApptypeModal'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import { httpAction,getAction } from '@/api/manage'
  import ApptypeApplicationModal from "./modules/ApptypeApplicationModal";
  import { getDictItemsFromCache } from '@/api/api'
  import { filterDictText } from '@/components/dict/JDictSelectUtil'
  import ApptypeApplicationListModal from "./modules/ApptypeApplicationListModal";

  export default {
    name: 'EmpBaseApptypeList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      ApptypeApplicationListModal,
      EmpBaseApptypeModal,
      ApptypeApplicationModal
    },
    data () {
      return {
        description: 'emp_base_apptype管理页面',
        // 表头
        /*columns: [

        ],*/
        url: {
          list: "/hhemp/apptype/empbaseapptypes",
          delete: "/hhemp/apptype/empbaseapptype",
          deleteBatch: "/hhemp/apptype/empbaseapptype/batch",
          exportXlsUrl: "/hhemp/apptype/export-xls",
          importExcelUrl: "hhemp/apptype/import-excel",
          publish: "/hhemp/apptype/publishstatus",

        },
        dictOptions:{},
        superFieldList:[],
        entrances:[{
          id:'',
          colName:'',
          entranceName:''
        }],
        applicationCode:'platform',
        previewVisible: false,
        previewImage: '',
        publishStatusList: [],
      }
    },
    created() {
    //this.getSuperFieldList();
      this.getEntranceList();
      this.publishStatusList = getDictItemsFromCache('sys_portal_up_down')
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      language() {
        return this.$store.getters.language
      },
      columns(){
        if(this.language){
          return [
            {
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
              width:150,
              title:this.language['emp.apptype.apptypeName'],// '分类名称',
              align:"center",
              dataIndex: 'appTypeName',
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              width:120,
              title:this.language['emp.apptype.apptypeCode'],// '分类编号',
              align:"center",
              dataIndex: 'appTypeCode',
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              width:100,
              title:this.language['emp.apptype.entrance'],
              align:"center",
              dataIndex: 'entranceName',
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              title:this.language['ad.image'],
              width: 100,
              ellipsis:true,
              align:"center",
              dataIndex: 'imgPath',
              scopedSlots: {customRender: "imgSlot"}
            },
            {
              width:100,
              title:this.language['emp.apptype.status'],// '发布状态',
              align:"center",
              dataIndex: 'publishStatus',
              //dataIndex: 'publishStatus_dictText'
              customRender: (text) => {
                return filterDictText(this.publishStatusList, text)
              },
            },
            /*{
              title:this.language['emp.apptype.publishPersion'],// '发布人/撤销人',
              align:"center",
              dataIndex: 'publisher'
            },
            {
              title:this.language['emp.apptype.publishTime'],// '发布时间/撤销时间',
              align:"center",
              dataIndex: 'publishTime',
              customRender:function (text) {
                return !text?"":(text.length>10?text.substr(0,10):text)
              }
            },*/
            {
              width:80,
              title:this.language['emp.apptype.sort'],
              align:"center",
              dataIndex: 'sortNo'
            },
            {
              title: this.language['common.action'],
              dataIndex: 'action',
              align:"center",
              //fixed:"right",
              width:147,
              scopedSlots: { customRender: 'action' }
            }
          ]
        }
      },
    },
    methods: {
      initDictConfig(){
      },
      getSuperFieldList(){
        let fieldList=[];
        fieldList.push({type:'string',value:'entranceId',text:'员工入口id',dictCode:''})
        fieldList.push({type:'string',value:'appTypeCode',text:'分类编号',dictCode:''})
        fieldList.push({type:'string',value:'appTypeName',text:'分类名称',dictCode:''})
        fieldList.push({type:'string',value:'publishStatus',text:'发布状态'})
        fieldList.push({type:'string',value:'publisher',text:'发布人/撤销人',dictCode:''})
        fieldList.push({type:'date',value:'publishTime',text:'发布时间/撤销时间'})
        fieldList.push({type:'int',value:'sortNo',text:'排序',dictCode:''})
        fieldList.push({type:'string',value:'delFlag',text:'刪除标示',dictCode:''})
        fieldList.push({type:'string',value:'remark',text:'备注',dictCode:''})
        this.superFieldList = fieldList
      },
      getEntranceList(){
        httpAction("/hhemp/entrance/empcmsentrances2?status=Y", "", "get").then((res) => {
          if (res.success) {
            this.entrances = res.result;
          }
        })
      },
      publish: function(record){
        var that = this;
        //上架
        this.$confirm({
          title:this.language["sys.dict.appstatus.publish"],
          content:this.language["emp.apptype.sureUpShelf"],
          onOk: function(){
            getAction(that.url.publish,{id:record.id,status:'up'}).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.loadData();
                that.onClearSelected();
              }else{
                that.$message.warning(res.message);
              }
            });
          }
        });
      },
      unpublish: function(record){
        var that = this;
        //上架
        this.$confirm({
          title:this.language["sys.dict.appstatus.unpublish"],
          content:this.language["emp.apptype.sureDownShelf"],
          onOk: function(){
            getAction(that.url.publish,{id:record.id,status:'down'}).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.loadData();
                that.onClearSelected();
              }else{
                that.$message.warning(res.message);
              }
            });
          }
        });
      },
      imgView(text){
        this.previewImage = text;
        this.previewVisible = true;
      },
      // 关闭模态框
      handleCancel() {
        this.previewVisible = false;
      },
      handleApplications(appTypeId,appTypeName,entranceId){
        this.$refs.apptypeApplicatonModal.appTypeSet(appTypeId,appTypeName,entranceId);
        this.$refs.apptypeApplicatonModal.title = this.language['portal.unitApp'];
      },
      applicationList(appTypeId,appTypeName,entranceName){
        this.$refs.apptypeApplicatonListModal.listdetail(appTypeId,appTypeName,entranceName);
        this.$refs.apptypeApplicatonListModal.title = this.language['user.apply.list'];
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
